const CreateGoodsReceiptDialogStyles = {
  dialog: {
    '& .MuiDialog-paper': {
      borderRadius: '16px',
      boxShadow: '0 8px 40px rgba(0, 0, 0, 0.12)',
      overflow: 'hidden',
      maxWidth: '500px',
      width: '100%'
    }
  },

  dialogTitle: {
    p: 3,
    borderBottom: '2px solid #e5e7eb',
    background: 'linear-gradient(135deg, #f8f9fa 0%, #ffffff 100%)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
  },

  titleText: {
    fontWeight: 600,
    fontSize: '1.25rem',
    color: '#1976d2',
  },

  closeButton: {
    color: 'grey.500',
    transition: 'all 0.2s ease',
    '&:hover': {
      backgroundColor: 'rgba(211, 47, 47, 0.08)',
      color: 'error.main',
      transform: 'rotate(90deg)'
    }
  },

  dialogContent: {
    p: 3,
    backgroundColor: '#fafbfc'
  },

  formField: {
    mb: 2.5,
    '& .MuiOutlinedInput-root': {
      borderRadius: '12px',
      backgroundColor: '#fff',
      transition: 'all 0.2s ease',
      '&:hover': {
        borderColor: '#1976d2',
      },
      '&.Mui-focused': {
        boxShadow: '0 0 0 3px rgba(25, 118, 210, 0.1)',
      }
    },
    '& .MuiInputLabel-root': {
      fontWeight: 500,
    }
  },

  fieldLabel: {
    fontWeight: 500,
    color: '#374151',
    mb: 1,
    fontSize: '0.875rem'
  },

  dialogActions: {
    p: 2.5,
    borderTop: '2px solid #e5e7eb',
    gap: 1.5,
    justifyContent: 'flex-start',
    backgroundColor: '#fafbfc'
  },

  cancelButton: {
    borderRadius: '10px',
    textTransform: 'none',
    fontWeight: 500,
    px: 3,
    py: 1,
    borderColor: '#d1d5db',
    color: '#6b7280',
    '&:hover': {
      borderColor: '#9ca3af',
      backgroundColor: '#f3f4f6'
    }
  },

  submitButton: {
    borderRadius: '10px',
    textTransform: 'none',
    fontWeight: 600,
    px: 3,
    py: 1,
    boxShadow: '0 2px 8px rgba(25, 118, 210, 0.3)',
    '&:hover': {
      boxShadow: '0 4px 12px rgba(25, 118, 210, 0.4)',
    },
    '&.Mui-disabled': {
      boxShadow: 'none'
    }
  },

  loadingBox: {
    display: 'flex',
    alignItems: 'center',
    gap: 1,
  },

  errorAlert: {
    mt: 2,
    borderRadius: '12px',
    border: '2px solid #EF5350',
    backgroundColor: '#FFEBEE',
  },

  infoAlert: {
    mb: 2,
    borderRadius: '12px',
    border: '2px solid #42A5F5',
    backgroundColor: '#E3F2FD',
  }
};

export default CreateGoodsReceiptDialogStyles;
